<template>


  <header id="headerx" class="header fFix">

    <div class="header-menu">
      <div class="col-sm-7">
        <!--<MenuToggle/>-->
        <div class="header-left">
          <!--<HeaderSearch/>-->
          <!--<HeaderNotification/>-->
          <!--<HeaderMessages/>-->
        </div>
      </div>
      <div class="col-sm-5">
      </div>
    </div>

    <div class="header-menu ">
      <!--<div class="col-12 col-md-6 mb-1">-->
      <div style="float: left;" class="X">

        <LinkToTemplate template="sellinone">

          <a data-template="sellinone" data-clear="true" class="linkToTemplate" href="#">
            <button type="button" class="btn btn-info btn-lg ">
              <i class="fa fa-shopping-cart"></i> {{$t('SellHeader.newSell')}}
            </button>
          </a>

        </LinkToTemplate>

        <LinkToTemplate template="buyer" v-if="buyerButton && Helper.checkRoles([3, 4, 5, 6, 7, 8, 9, 10], user_role)">
          <a data-template="buyer" data-clear="true" class="linkToTemplate" href="#">
            <button type="button" class="btn btn-info btn-lg ">
              <i class="fa fa-user"></i> {{$t('SellHeader.newBuyer')}}
            </button>
          </a>
        </LinkToTemplate>

        <LinkToTemplate template="businesspartner" v-if="businessPartnerButton && Helper.checkRoles([3, 4, 5, 6, 7, 8, 9, 10], user_role)">
          <a data-template="buyer" data-clear="true" class="linkToTemplate" href="#">
            <button type="button" class="btn btn-info btn-lg ">
              <i class="fa fa-briefcase"></i> {{$t('SellHeader.newBusinessPartner')}}
            </button>
          </a>
        </LinkToTemplate>

        <LinkToTemplate template="transactions" v-if="transactionsButton && Helper.checkRoles([3, 4, 5, 6, 7, 8, 9, 10], user_role)">





          <a data-template="transactions" data-clear="true" class="linkToTemplate" href="#">
            <button type="button" class="btn btn-info btn-lg ">
              <i class="fa fa-bolt"></i> {{$t('SellHeader.transactions')}}
            </button>
          </a>
        </LinkToTemplate>


        <div class="header-left">
        </div>
      </div>
      <!--<div class="ol-12 col-md-6">-->
      <div style="float: right;" class="X mr15">
        <div class="float-right text-nowrap">
          <!--<User/>-->


          <!--<LinkToTemplate template="landingpage">-->
          <!--<a data-template="landingpage" data-clear="true" class="linkToTemplate" href="#">-->
          <!--<button type="button" class="btn btn-info btn-lgx ">-->
          <!--<i class="fa fa-gear"></i> landingpage-->
          <!--</button>-->
          <!--</a>-->
          <!--</LinkToTemplate>-->


          <span>
                        <LinkToTemplate template="businesspartners" v-if="businessPartnerButton && Helper.checkRoles([3, 4, 5, 6, 7, 8, 9, 10], user_role)">
                            <a data-template="businesspartners" data-clear="true" class="linkToTemplate" href="#">
                                <button type="button" class="btn btn-info ">
                                    <i class="fa fa-briefcase"></i>
                                </button>
                            </a>
                        </LinkToTemplate>
                    </span>


          <span class="spanLinkToTemplate">






                    <!--<button type="button" class="btn btn-info btn-reprint" v-on:click="reprint()">-->
                        <!--<i class="fa fa-print"></i>-->
                    <!--</button>-->
                    </span>

          <!--<BtnUpdate></BtnUpdate>-->

          <LinkToTemplate template="setting">
            <a data-template="setting" data-clear="true" class="linkToTemplate" href="#" v-if="Helper.checkRoles([4,5,6,7,8,9,10], user_role)">
              <button type="button" class="btn btn-info btn-lgx ">
                <i class="fa fa-gear"></i>
              </button>
            </a>
          </LinkToTemplate>

          <!--class="btn  btn-outline-infoX btn-info language-select-container"-->
          <!--<span class="  btn  btn-outline-infoX btn-info language-select-container" v-on:click="choose()">-->
          <LngChooser id="LngChooserModul" asButton="true"/>
          <!--</span>-->

          <LinkToTemplate template="closes" v-if="closesButton && Helper.checkRoles([3,4,5,6,7,8,9,10], user_role)">






            <a data-template="closes" data-clear="true" class="linkToTemplate" href="#">
              <button type="button" class="btn btn-info btn-lgx ">
                <i class="fa fa-clock-o"></i> {{$t('SellHeader.closes')}}
              </button>
            </a>
          </LinkToTemplate>


          <LinkToTemplate template="login">
            <a data-template="login" data-clearTarget="true" data-clear="true" class="linkToTemplate" href="#" data-confirm="Biztos kilép?">
              <button type="button" class="btn btn-info btn-smX btn-logoff">
                <i class="fa fa-sign-out"></i> {{$t('SellHeader.logout')}}
              </button>
            </a>
          </LinkToTemplate>

          <span class="spanLinkToTemplate">
                    <BtnFullScren>
                        <button type="button" class="btn btn-primary btn-smX btn-fullScren">
                            <i class="fa fa-arrows-alt"></i>
                        </button>
                    </BtnFullScren>
                  </span>
          <span class="spanLinkToTemplate">
                    <BtnExit>
                        <button type="button" class="btn btn-danger btn-smX btn-exit">
                            <strong>X</strong>
                        </button>
                    </BtnExit>
          </span>

        </div>

      </div>
      <div style="clear: both"></div>

      <small class="version">{{version}}</small>
      <table class="w100">
        <tr>
          <td class="text-right lh15"><span class="mr15"><AdminUserDisplay></AdminUserDisplay></span></td>
        </tr>
      </table>

    </div>
  </header>

</template>

<script>


  import LngChooser from '@/components/LngChooser.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Helper from '@/helper/Helper';

  import LinkToTemplate from "@/components/LinkToTemplate";
  //    import BtnUpdate from "@/components/BtnUpdate";
  import BtnFullScren from "@/components/BtnFullScren";
  import BtnExit from "@/components/BtnExit";
  import AdminUserDisplay from '@/components/AdminUserDisplay.vue';
  //    const {ipcRenderer} = require('electron');

  export default {
    name: 'SellHeader',
    data() {
      return {
        data: {},
        buyerButton: true,
        businessPartnerButton: true,
        transactionsButton: true,
        closesButton: true,
        version: "",
        Helper: Helper,
        user: {},
        companyname: "",
        storename: "",
        user_role: "",
        username: "",
      };
    },
    watch: {
      '$store.state.companyname': function (newVal, oldVal) {
        const modul = this;
        const companyname = (modul.$store.state && modul.$store.state.companyname) ? modul.$store.state.companyname : "";
        modul.companyname = companyname;
      },
      '$store.state.storename': function (newVal, oldVal) {
        const modul = this;
        const storename = (modul.$store.state && modul.$store.state.storename) ? modul.$store.state.storename : "";
        modul.storename = storename;
      },
      '$store.state.user': function (newVal, oldVal) {
        const modul = this;
        const user = (modul.$store.state && modul.$store.state.user ) ? modul.$store.state.user: {};
        const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
        modul.role = role;
        modul.user = user;
        modul.username = (user.real_name)?user.real_name:"";
      },
    },

    mounted() {
      const modul = this;
      const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
      modul.user_role = role;
      const user = (modul.$store.state && modul.$store.state.user ) ? modul.$store.state.user: {};
      modul.username = (user.real_name)?user.real_name:"";

      const companyname = (modul.$store.state && modul.$store.state.companyname) ? modul.$store.state.companyname : "";
      modul.companyname = companyname;
      const storename = (modul.$store.state && modul.$store.state.storename) ? modul.$store.state.storename : "";
      modul.storename = storename;

      if (localStorage.getItem("buyerButton") && localStorage.getItem("buyerButton") === "false") {
        modul.buyerButton = false;
      }
      if (localStorage.getItem("businessPartnerButton") && localStorage.getItem("businessPartnerButton") === "false") {
        modul.businessPartnerButton = false;
      }
      if (localStorage.getItem("transactionsButton") && localStorage.getItem("transactionsButton") === "false") {
        modul.transactionsButton = false;
      }
      if (localStorage.getItem("closesButton") && localStorage.getItem("closesButton") === "false") {
        modul.closesButton = false;
      }
      modul.initListener();
      modul.doListener();
      modul.$eventBus.$on('globalReadAndSetSettings', this.globalReadAndSetSettingsEventHandler);
//      modul.user_role = (window.user && window.user.user_role) ? window.user.user_role : 0;
      modul.user_role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;

    },
    beforeDestroy() {
      const modul = this;
      modul.offListener();
      modul.$eventBus.$off('globalReadAndSetSettings');
    },

    methods: {
      method(){
        const modul = this;
      },
      choose(){
//                const modul = this;
//                const el = document.getElementById('language');
//                if (el) {
//                    if (!(document.getElementById('lng-dropdown-menu') && document.getElementsByClassName('lng-dropdown-menu')[0].classList.contains("show"))) {
//                        el.click();
//                    }
//                }
      },
      globalReadAndSetSettingsEventHandler(){
        const modul = this;
        modul.user_role = (window.user && window.user.user_role) ? window.user.user_role : 0;
      },
      doListener: function () {
//                ipcRenderer.send('getversion', 'ping');
      },
      initListener: function () {
        const modul = this;
//                ipcRenderer.removeAllListeners('getversion-reply');
//                ipcRenderer.on('getversion-reply', (event, arg) => {
//                    console.log(arg);
//                    if (arg && arg.version) {
//                        modul.version = arg.version;
//                    }
//                });
      },
      offListener: function () {
//                ipcRenderer.removeAllListeners('getversion-reply');
      },

      reprint: function () {
        const modul = this;
        modul.getLastSellId(function (err, res) {
          if (res && res[0] && res[0].id) {
            const sellprintId = res[0].id;
            modul.$router.push({
              name: "sellprint", params: {
                sellId: sellprintId,
              }
            });

          }
        });
      },
      getLastSellId: function (cb, id) {
        console.log("getLastSellId");
        window.db.select(
          function (err, res) {
            cb(err, window.db.convertResToArray(err, res))
          }
          , "sell ", "id", "1", "id desc", "1");
      },
    },
    components: {
      LinkToTemplate,
      BtnFullScren,
      BtnExit,
      LngChooser,
      AlertInPage,
      AdminUserDisplay,
//            BtnUpdate,
    },
  };
</script>

<style scoped>
  body .language-select-container {
    margin: 0 0 0 0;
    float: none;
    display: inline-block;

  }

  body #language-select {
    margin: 0 0 0 0;
    float: none;
    display: inline-block;
    /* btn btn-info */
  }

  .lh15 {
    line-height: 10px;
  }

  .version {
    font-size: 10px;
    color: #888;
    position: absolute;
    right: 1px;
    top: 0;
  }
  .headerinformations {
    font-size: 14px;
    line-height: 12px;
  }
</style>
